import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import { API_BASE_URL } from 'redux/constants'
import { Image_BASE_URL } from 'redux/constants'
import { AccountSignIn } from 'services/Sys-ConfigServices'


function useAuth() {

	const dispatch = useDispatch()

	const navigate = useNavigate()

	const query = useQuery()

	const { token, signedIn } = useSelector((state) => state.auth.session)


	const signIn = async ({ userName, password }) => {
		try {
			var resp = await AccountSignIn(userName, password);
			console.log(resp);
			if (resp.data.userType === "Customer") {
				return {
					status: 'failed',
					message: "Logoi Failed"
				}
			}
			else {
				if (resp.status) {

					dispatch(onSignInSuccess(resp.data.id))
					if (resp.data) {
						dispatch(setUser({
							id: resp.data.id,
							avatar: "",
							userName: resp.data.firstName,
							authority: [resp.data.userType],
							email: resp.data.email,
							token: resp.token
						}));
					}

					// Conditional navigation based on userType
					const redirectUrl = query.get(REDIRECT_URL_KEY);
					if (resp.data.userType === 'Vendor') {
						navigate("/vendorDashboard");
					} else if (resp.data.userType === 'Admin') {
						navigate("/dashboard");
					} else {
						// Default navigation
						navigate("/dashboard");
					}

					return {
						status: 'success',
						message: ''
					}
				} else {
					return {
						status: 'failed',
						message: resp.message
					}
				}
			}

		} catch (errors) {
			return {
				status: 'failed',
				message: resp?.message || errors.toString()
			}
		}
	}

	const handleSignOut = () => {
		dispatch(onSignOutSuccess())
		dispatch(setUser(initialState))
		navigate(appConfig.unAuthenticatedEntryPath)
		localStorage.clear('items')
		window.location.reload()
	}

	const signOut = async () => {
		try {
			await apiSignOut()
			handleSignOut()
		} catch (errors) {
			handleSignOut()
		}
	}

	return {
		authenticated: token && signedIn,
		signIn,
		signOut
	}
}

export default useAuth